module.exports = __webpack_public_path__ + "img/undraw_Receipt_re_fre3.4c64aeca.svg";